<template>
 <!-- <PuSkeleton class=" Skeletonitem1" height="inherit" style="padding:0 ;  " v-if=" loader== true"  /> -->
    
    <div class="storeSlider">
    <slick class="" ref="slickfive" v-if="data.length" :options="slickOptions" >
        <div v-for="(item, i) in data" :key="i">
          <a :href="`/category/${item.category_name}.html?store=${$route.query.store}&category=${item.category_id}&name=%20Fashion&isFromStore=true`" @click.native="(e)=> dragging && e.preventDefault()">
           <img :src="item.img_path" alt="" class="w-100" title=""/>
          
          </a>
          
          <!-- <router-link
            
            :to="{ name: 'StoreProduct', query: { store: $route.query.store, category:item.category_id ,
                   name:item.category_name} }"
                   @click.native="(e)=> dragging && e.preventDefault()"
            
          >
            <img :src="item.img_path" alt="" class="w-100" title="" />
            
          </router-link> -->
        </div>
      </slick>
    </div>
</template>
<script>
import slick from "vue-slick";
export default {
    components: { slick },
    props:["data",'loader'],
    
   data() {
    return {
        slider:'',
        slider_show:false,
        dragging: false,
        slickOptions: {
          slidesToShow: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          pauseOnFocus: false,
          pauseOnHover: false,
          pauseOnDotsHover: true,
          arrows: false,
          dots:true, 
          beforeChange: () => this.dragging = true,
          afterChange: () => this.dragging = false,
        //   draggable:true,
        // swipeToSlide:true,
        // touchMove:true
        // Any other options that can be got from plugin documentation
      },
    }
    
    }
}
</script>
<style scoped>

/* @media screen and (min-width: 1000px) {
    .storeSlider{
      min-height:500px ;
    }
} */

</style>